module.exports = __webpack_public_path__ + "img/snow_fall_00039.a8cd9b8e.png";